import "./QuizQuestionResult.scss";

import { Flex, Table, Text } from "@fluentui/react-northstar";
import { Question, QuestionType, TeamsSurveyResponse } from "@teams/types";
import { SurveyDTO, SurveyResponsesDTO } from "@teams/types/api";
import React from "react";

import { PollyIcon } from "../../../../../_shared/components/PollyIcon";
import { useUserResponseValue } from "../../hooks/useUserResponeValue";
import { QuestionResultsGraph } from "../QuestionResultsGraph";

type Props = {
  survey: SurveyDTO;
  question: Question<QuestionType>;
  results: SurveyResponsesDTO;
  questionNo: number;
};

export const QuizQuestionResult: React.FC<Props> = ({ survey, question, results, questionNo }) => {
  return (
    <Flex column gap="gap.medium">
      <Flex column gap="gap.medium" className="question-result-container">
        <Flex fill>
          <Text
            align="start"
            content={`Q${questionNo}.`}
            className="question-result-container__question-no"
          />
          <Text
            align="start"
            content={question.label}
            className="question-result-container__question-label"
          />
        </Flex>

        <QuestionResultsGraph
          question={question}
          role={survey.role}
          responses={results.responses}
          anononymity={survey.anonymity}
          canViewResults={results.canViewResponses}
          userResponse={results.userResponse}
          darkBackground={true}
        />
      </Flex>
      {
        survey.role === "own" && (
        <Flex  column gap="gap.small" className="responders-container">
          <Flex gap="gap.smaller" vAlign="center">
            <PollyIcon icon="completions-icon" inheritColor />
            <Text content={`Responses ${results.responses.length}`} weight="bold" />
          </Flex>

          <Table
            compact
            className="responders-table"
            header={[
              <Text content="User Name" weight="bold" />,
              <Text content="Answer" weight="bold" />,
              ...(question.allowComments ? [<Text content="Comments" weight="bold" />] : []),
            ]}
            rows={results.responses.map(response => {
              return {
                key: response.id,
                styles: { minHeight: "36px", height: "unset" },
                items: [
                  <div key={`${response.id}-name-cell`}>{response.user.name}</div>,
                  <UserRowResponse
                    key={`${response.id}-response-cell`}
                    question={question}
                    response={response}
                  />,
                  ...(question.allowComments
                    ? [
                        <UserRowComment
                          key={`${response.id}-comment-cell`}
                          question={question}
                          response={response}
                        />,
                      ]
                    : []),
                ],
              };
            })}
          />
        </Flex> )
      }
    </Flex>
  );
};

const UserRowResponse: React.FC<{
  question: Question<QuestionType>;
  response: TeamsSurveyResponse | undefined;
}> = ({ question, response }) => {
  return <>{useUserResponseValue(question, response)}</>;
};

const UserRowComment: React.FC<{
  question: Question<QuestionType>;
  response: TeamsSurveyResponse;
}> = ({ question, response }) => {
  const userResponse = response.responses.find(r => r.questionId === question.id);
  return <div>{userResponse?.comment || ""}</div>;
};
